'use strict';

const promotionModal = {
    cache: {
        $document: $(document),
        $modal: $('#promotionModal')
    },
    init() {
        this.cache.$modal.on('show.bs.modal', function (e) {
            var $modal = $(this);
            var $modalBody = $modal.find('.js-modal-body');
            var $modalTrigger = $(e.relatedTarget);
            var modalContent =  $modalTrigger.data('modal-content');

            if ($modalBody && modalContent) {
                $modalBody.html(modalContent);
            }
        });

        this.cache.$document.on('viewportchange', () => {
            if (this.cache.$modal) {
                this.cache.$modal.modal('hide');
            }
        });
    }
};

module.exports = promotionModal;
